import React, { useEffect, useState } from 'react';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/launchprocess.css';
import { getHowItWorkData } from '../../apis/apiAction';

const Howitwork = () => {
    const [BannerData, setBannerData] = useState([]);
  
  
    useEffect(() => {
      getBannerData();
    }, []);
  
    const getBannerData = async () => {
      try {
        let res = await getHowItWorkData()
        console.log(res.data)
        if (res.data) {
          setBannerData(res.data);
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };

  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        <section>
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} className="text-center px-lg-5">
                <h1 className="text-white">
                  {/* Making Crypto Investment Safer with Blockchain  */}
                  {BannerData.firstHeading}
                </h1>
                <h5 className="my-4 text-primary">
                  {/* A Seamless and Decentralized Future */}
                  {BannerData.secondHeading}
                </h5>
                <p>
                  {BannerData.description}
                  {/* Unitronix is redefining crypto investment security by
                  eliminating inefficiencies and introducing transparency,
                  automation, and direct asset management through blockchain
                  technology. Our decentralized approach reduces risk, enhances
                  liquidity, and empowers investors with a secure, thrustless
                  financial ecosystem. */}
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className=" pt-0" id="safer">
          <Container className="position-relative">
            <Row className="align-items-center">
              <Col lg={6} className="mb-4">
                <div className="heading mb-4">
                  <h3 className="text-white fw-semibold mb-0">
                    How Unitronix Makes Crypto Investing Safer
                  </h3>
                </div>
                <div className="">
                  <div>
                    <ul className="">
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                          {/* Tokenization for Security & Liquidity : */}
                          {BannerData.innovations01Heading}
                        </b>{' '}
                        {BannerData.innovations01Description}
                        {/* By converting real-world assets, debt instruments, and
                        equity into digital tokens, Unitronix enhances
                        liquidity, accessibility, and investor protections.
                        Smart contracts ensure secure transactions, predefined
                        rules, and automatic execution, eliminating the need for
                        intermediaries. */}
                      </li>
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                          {/* Automated Risk Management & Asset Lifecycle Protection
                          : */}
                          {BannerData.innovations02Heading}
                        </b>{' '}
                        {BannerData.innovations02Description}

                        {/* With blockchain-powered lifecycle management, financial
                        instruments are handled from issuance to settlement
                        without manual intervention. For instance, convertible
                        debt automatically converts into equity when conditions
                        are met—removing human error and delays. */}
                      </li>
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                          {/* Smart Contracts for Secure, Tamper-Proof Transactions
                          : */}
                        {BannerData.innovations03Heading}

                        </b>{' '}
                        {BannerData.innovations03Description}
                        {/* Unitronix’s self-executing smart contracts lock in rules
                        for investment protection, preventing fraud,
                        mismanagement, or unauthorized modifications. Every
                        transaction is auditable, transparent, and immutable on
                        the blockchain. */}
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col lg={1} className="mb-4"></Col>
              <Col lg={5} className="mb-4">
                <div className="p-5">
                  <img
                    src="assets/images/Investingsafer.svg"
                    className="w-100"
                  />
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={5} className="mb-4">
                <div className="p-5">
                  <img
                    src="assets/images/safetymechanisms.png"
                    className="w-100"
                  />
                </div>
              </Col>
              <Col lg={1} className="mb-4"></Col>
              <Col lg={6} className="mb-4">
                <div className="heading mb-4">
                  <h3 className="text-white fw-semibold mb-0">
                    Innovative Safety Mechanisms
                  </h3>
                </div>
                <div className="">
                  <div>
                    <ul className="">
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                          {/* Tokenization for Security & Liquidity : */}
                          {BannerData.innovations01Heading}
                        </b>{' '}
                        {BannerData.innovations01Description}
                        {/* By converting real-world assets, debt instruments, and
                        equity into digital tokens, Unitronix enhances
                        liquidity, accessibility, and investor protections.
                        Smart contracts ensure secure transactions, predefined
                        rules, and automatic execution, eliminating the need for
                        intermediaries. */}
                      </li>
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                        {BannerData.innovations02Heading}

                          {/* Automated Risk Management & Asset Lifecycle Protection
                          : */}
                        </b>{' '}
                        {BannerData.innovations02Description}

                        {/* With blockchain-powered lifecycle management, financial
                        instruments are handled from issuance to settlement
                        without manual intervention. For instance, convertible
                        debt automatically converts into equity when conditions
                        are met—removing human error and delays. */}
                      </li>
                      <li className="mb-3">
                        <b className="text-white fw-medium">
                        {BannerData.innovations03Heading}

                          {/* Smart Contracts for Secure, Tamper-Proof Transactions
                          : */}
                        </b>{' '}
                        {BannerData.innovations03Description}

                        {/* Unitronix’s self-executing smart contracts lock in rules
                        for investment protection, preventing fraud,
                        mismanagement, or unauthorized modifications. Every
                        transaction is auditable, transparent, and immutable on
                        the blockchain. */}
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <p></p>
        <section id="real-world-case-study" className="missionvision py-0">
          <Container>
            <Row>
              <Col lg={6} className="mb-4">
                <Card className="blueCard">
                  <Card.Body className="p-0">
                    <div>
                      <div className="p-4 z-1">
                        <h2 className="mb-4 text-white">
                          Real-World Case Study
                        </h2>
                        {/* <h5 className="mb-2 text-white">
                          See How Unitronix Smart Contracts Secure Investments
                        </h5> */}
                        <p className=" my-4">
                          {BannerData.realWorldCaseStudyDescription01}
                          {/* Meet <b className="text-white">Sarah</b>, an Investor
                          Seeking Safe Crypto Returns{' '} */}
                        </p>
                        <p>
                        {BannerData.realWorldCaseStudyDescription02}

                          {/* Sarah invests <b className="text-white">$1,000</b> in
                          a tokenized RWAs project with an expected{' '}
                          <b className="text-white">50% ROI ($1,500)</b> in{' '}
                          <b className="text-white">6months.</b> */}
                        </p>
                        {/* <p>
                          {' '}
                          However,{' '}
                          <b className="text-white">
                            3 months later, the market turns bearish, and the
                            token price drops below $40
                          </b>
                          —activating Unitronix’s{' '}
                          <b className="text-white">
                            Smart Contract Protection Mechanism.
                          </b>
                        </p> */}
                      </div>
                      <div className="blogImg text-end">
                        <img
                          src="assets/images/sarah.svg"
                          className=" object-fit-contain"
                          style={{ width: 'auto' }}
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6} className="mb-4">
                <Card className="blueCard">
                  <Card.Body className="p-0">
                    <div>
                      <div className="p-4 z-1">
                        <h2 className="mb-2 text-white">
                          Automatic Protection Mechanism in Action
                        </h2>

                        <div className="mt-4">
                          <ul>
                            <li className="mb-3 ">
                              {/* <p>
                                <b className="text-white">
                                  Trigger Condition Met :
                                </b>{' '}
                                Token price falls to{' '}
                                <b className="text-white">$35</b>, breaching the{' '}
                                <b className="text-white">40% threshold.</b>
                              </p> */}
                              {BannerData.automaticProtectionMechanismDescription01}
                            </li>

                            <li className="mb-3 ">
                              {/* <p>
                                <b className="text-white">
                                  Smart Contract Action :
                                </b>{' '}
                                Sarah’s{' '}
                                <b className="text-white">
                                  $1,000 principal is immediately repaid in
                                  USDT.
                                </b>
                              </p> */}
                              {BannerData.automaticProtectionMechanismDescription02}

                            </li>

                            {/* <li className="">
                              <p>
                                <b className="text-white">
                                  Outcome : Sarah’s capital is fully protected
                                </b>{' '}
                                from further market declines.
                              </p>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div className="particleImg position-relative text-end">
                          <img src="assets/images/particle.gif" />
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="keybenefits ">
          <Container>
            <Row>
              <Col lg={12} className="mb-5 pb-5">
                <div className="text-center">
                  <div className="">
                    <h1 className="text-white">
                      Why Unitronix is the Safer Way to Invest in Crypto
                    </h1>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="">
                <Row>
                  <Col lg={4} md={6} className="mb-5">
                    <Card className="text-center">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/costefficiency.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">Capital Protection</h4>
                            <p>
                              {' '}

                              {/* If market conditions worsen, smart contracts
                              automatically safeguard investments. */}
                              {BannerData.capitalProtection}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} className="mb-5">
                    <Card className="text-center">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/oversight.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">
                              No Manual Intervention Required{' '}
                            </h4>
                            <p>
                              {BannerData.noManualInterventionRequired}
                              {/* Investments are secured and executed automatically
                              based on predefined conditions. */}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} className="mb-5">
                    <Card className="text-center">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/global.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <h4 className="text-white">
                              Confidence in the Crypto Market{' '}
                            </h4>
                            <p>
                              {BannerData.confidenceInTheCryptoMarket}
                              {/* Investors can engage in high-growth opportunities
                              without excessive risk exposure. */}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
};
export default Howitwork;
